import { Fragment, ReactElement, useMemo } from 'react';
import { CohabitationNotificationsCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CohabitationNotificationsSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { CohabitationNotificationsMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { CohabitationNotificationsCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { useParams } from 'react-router-dom';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { CohabitationNotificationsCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchCohabitationNotificationShared from '../../research-notifications/research-cohabitation';

interface ResearchCohabitationNotificationCivilStatusSharedProps {
  scope?: string;
}

const ResearchCohabitationNotificationCivilStatusShared = ({
  scope,
}: ResearchCohabitationNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const destinationUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}/convivenza/nascita`;
  }, [scope, idAnsc, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return CohabitationNotificationsCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return CohabitationNotificationsCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return CohabitationNotificationsSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return CohabitationNotificationsMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return CohabitationNotificationsCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, goBackUrl, idCat]);

  return (
    <Fragment>
      <ResearchCohabitationNotificationShared
        goBackUrl={goBackUrl}
        items={items}
        destinationUrl={destinationUrl}
      />
    </Fragment>
  );
};

ResearchCohabitationNotificationCivilStatusShared.displayName =
  'Research Cohabitation Notifications Page component';

export default ResearchCohabitationNotificationCivilStatusShared;
